import { concat, map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type PronounSelectInput_query$key } from '@/__generated__/PronounSelectInput_query.graphql'
import {
  SingleSelectInput,
  type SingleSelectInputProps,
  type SingleSelectInputRef,
  type SingleSelectOption
} from '@/components'

export type PronounSelectInputProps = Omit<SingleSelectInputProps, 'options' | 'ref'> & {
  queryRef: PronounSelectInput_query$key | null | undefined
}

export const PronounSelectInput = forwardRef<SingleSelectInputRef, PronounSelectInputProps>(
  ({ queryRef, ...props }, ref) => {
    const queryData = useFragment(
      graphql`
        fragment PronounSelectInput_query on Query {
          pronouns(orderBy: [SEQUENCE_ASC]) {
            nodes {
              name
              rowId
            }
          }
        }
      `,
      queryRef
    )

    return (
      <SingleSelectInput
        options={useMemo<SingleSelectOption[]>(
          () =>
            concat(
              map(queryData?.pronouns?.nodes, (pronoun) => ({
                label: pronoun!.name,
                value: pronoun!.rowId
              })),
              [{ label: 'Don’t Show This', value: null }]
            ),
          [queryData?.pronouns?.nodes]
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

PronounSelectInput.displayName = 'PronounSelectInput'
